import services from '../../../services';
import { hearingTaskList, deleteTask, makeIrc } from '../../../services/urlConfig';
// 展示列表的方法
export function requestTaskList(params = {}) {
  const res = services[hearingTaskList.type](hearingTaskList.url, params);
  return res;
}
// 删除任务的方法
export function deleteHearingTask(params = {}) {
  const res = services[hearingTaskList.type](deleteTask.url, params);
  return res;
}

export function createTask(params = {}) {
  return services[makeIrc.type](makeIrc.url, params, { errorToast: true });
}
